import { render, staticRenderFns } from "./ShopProductsPayment.vue?vue&type=template&id=733a49c5&scoped=true&"
import script from "./ShopProductsPayment.vue?vue&type=script&lang=js&"
export * from "./ShopProductsPayment.vue?vue&type=script&lang=js&"
import style0 from "./ShopProductsPayment.vue?vue&type=style&index=0&id=733a49c5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "733a49c5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VBtn,VCheckbox,VForm})
